import {Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {VakdashboardNewFacade} from '../../state/vakdashboard/vakdashboard.facade';
import {ControlsHeaderViewModel} from '../controls-header/controls-header.component';
import {DashboardsettingsFacade} from '../../state/dashboardsettings/dashboardsettings.facade';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {takeWhile} from 'rxjs/operators';
import { DatepickerComponentViewModel } from '../datepicker/datepicker.component';
import { Datumbereik } from 'src/app/state/dashboardsettings/dashboardsettings.state';
import {routingConstants} from '../../stateless/routing.constants';

@Component({
    selector: 'app-vakdashboard-new',
    templateUrl: './vakdashboard-new.component.html',
    styleUrls: ['./vakdashboard-new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VakdashboardNewComponent implements OnInit, OnDestroy {

  public controlsViewmodel: ControlsHeaderViewModel & DatepickerComponentViewModel;

  private subscriptions: Subscription[] = [];

  public loading: Observable<boolean> = this.store.selectLoading();
  public initialLoadingFinished = false;

  constructor(private settings: DashboardsettingsFacade, private store: VakdashboardNewFacade, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const terugKnopViewmodel = {
        caption: 'Terug naar Schooldashboard',
        pathElements: [routingConstants.SCHOOL_DASHBOARD_NEW],
    };

    this.subscriptions.push(
      combineLatest([this.store.getHoofdItem(),
        this.store.getSubItem(),
        this.store.getPrevPathElements(),
        this.store.getNextPathElements()])
        .subscribe(([hoofdItem, subItem, prevPathElements, nextPathElements]) => {
          const vakOnderwijsSwitchViewmodel = {hoofdItem, subItem, prevPathElements, nextPathElements};
          this.controlsViewmodel = {
            terugKnopViewmodel,
            vakOnderwijsSwitchViewmodel,
            onGetCurrentDatumbereik: this.settings.getDatumbereik(),
            onGetMogelijkeDatumbereiken: this.settings.getDatumbereiken(),
            onGetSelectedVestiging: this.settings.getSelectedVestiging(),

            setSelectedDatumbereik: (datumbereik: Datumbereik) => this.settings.setDatumbereik(datumbereik)
          };
          this.cdr.detectChanges();
        }));

    this.loading.pipe(
      takeWhile((loading) => loading === true, true),
    ).subscribe((loading) => {
      if (loading === false) {
        this.initialLoadingFinished = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
